<div class="card right">
  <div class="ui-g form-group master-data">

    <div class="ui-g-12">
      <h1 class="campaign-step">{{ 'campaign.couponType' | translate }}</h1>
    </div>
    <div class="ui-g-4" *ngFor="let coupon of campaign.coupons">
      <button pButton type="button" class="Couponh" icon="{{ coupon.icon }}" iconPos="left" label="{{ coupon.name }}" [ngClass]="{'active': panel == coupon.type_code}" (click)="setPanel(coupon.type_code)">
        <div class="active-alert" *ngIf="coupon.active">{{ 'campaign.active' | translate }}</div>
      </button>
    </div>

    <div *ngFor="let coupon of campaign.coupons" class="ui-g-12 ui-g-nopad">
      <div *ngIf="panel == coupon.type_code">

        <div class="ui-g-12 recommended">
          {{ 'campaign.recommended' | translate }}
        </div>

        <div class="ui-g-12">
          <div class="ui-g-6">
            <div class="inputetesto">
              <p-inputSwitch [(ngModel)]="coupon.active" (onChange)="toggleActive(coupon, $event)"></p-inputSwitch>
              <div class="input-text" *ngIf="coupon.active">{{ 'campaign.typeOfCoupon' | translate }} <span class="statusC">{{ 'campaign.activated' | translate }}</span></div>
            </div>
          </div>
          <div class="ui-g-6" *ngIf="coupon.active">
            <button pButton type="button" class="Coupon-preview" icon="fa fa-eye" iconPos="left" label="Preview del Coupon" (click)="couponPreview(coupon.type_code)"></button>
          </div>
        </div>

        <div class="ui-g-12" *ngIf="coupon.active">

          <div class="ui-g-8">
            <div class="coupon-setting">{{ 'campaign.couponSettings' | translate }}</div>
          </div>
          <div class="ui-g-4">
            <div class="box-range"><i class="fa fa-square squarecolor" aria-hidden="true"></i></div>
            <div class="recommended-range">{{ 'campaign.reccomendedRange' | translate }}</div>
          </div>

          <!-- extra 1 -->
          <div class="ui-g-12" *ngIf="coupon.active && coupon.type_code == 1">
            <app-coupons-sliders
            [coupon]="coupon"
            [typeCode]="coupon.type_code"
            (couponSettingsChanged)="resetCoupons($event)"
            >
            </app-coupons-sliders>
          </div>
          <!-- end extra 1 -->

          <!-- extra 2 -->
          <div class="ui-g-12" *ngIf="coupon.active && coupon.type_code == 2">
            <div class="subtitle">
              <div class="campaign-coupon-sub">{{ 'campaign.assignCategory' | translate }}</div>
            </div>
            <div class="ui-g-12" *ngFor="let category of categories; let i = index">
              <p-checkbox
              name="selectedCategories"
              value="{{ category.codice_categoria }}"
              label="{{ category.categoria_offerta }}"
              [(ngModel)]="coupon.categories"
              (onChange)="resetCoupons(coupon.type_code)"></p-checkbox>
              <app-category-coupons-slider
              [coupon]="coupon"
              [selectedCategories]="selectedCategories"
              [suggestedCategoriesData]="suggestedCategoriesData"
              [category]="category"
              [typeCode]="coupon.type_code"
              (couponSettingsChanged)="resetCoupons($event)"
              [returnedSavedCategories]="returnedSavedCategories"></app-category-coupons-slider>
            </div>
          </div>
          <!-- end extra 2 -->

          <!-- extra 3 -->
          <div class="ui-g-12" *ngIf="coupon.active && coupon.type_code == 3">
            <ul class="product-coupons">
              <li class="product-coupons__single" *ngFor="let productCoupon of productCouponsF; let i = index">
                  <div class="product-coupons__single__header ui-g-12">
                    <div class="ui-g-11">
                      <h1 style="border-bottom: 0;">Coupon {{i + 1}}</h1>
                    </div>
                    <div class="ui-g-1">
                      <i class="fa fa-2x fa-times product-coupons__single__delete" (click)="deleteProductCoupon(i, coupon.type_code)"></i>
                    </div>
                  </div>
                  <app-coupons-sliders
                  [coupon]="coupon"
                  [productCoupon]="productCoupon"
                  [typeCode]="coupon.type_code"
                  (couponSettingsChanged)="resetCoupons($event)"
                  >
                  </app-coupons-sliders>

                  <kv-search-toolbar
                  [couponCategoryFilter]="true"
                  [productsBoxEnabled]="true"
                  appQFilter
                  (onGetCouponProducts)="getCouponProductsF($event, productCoupon)"
                  >
                  </kv-search-toolbar>
                  <div class="ui-g-12 search-toolbar-buttons">
                    <div class="ui-g-9"></div>
                    <div class="ui-g-3">
                      <button class="k-generic-btn pull-right" pButton type="button" (click)="applyCouponProductsFilter(productCoupon)" name="search" icon="fa fa-search"
                              label="{{ 'common.apply' | translate}}"></button>
                    </div>
                  </div>
                  <div class="ui-g-12" *ngIf="productCoupon.showProductsTable">
                      <p-table class="product-table" [value]="productCoupon.products" [paginator]="true" [rows]="10">
                        <ng-template pTemplate="header">
                            <tr>
                                <th></th>
                                <th>Ean</th>
                                <th>{{ 'campaign.itemCode' | translate }}</th>
                                <th>{{ 'campaign.itemDescription' | translate }}</th>
                                <th>{{ 'campaign.soldLastMonth' | translate }}</th>
                                <th>{{ 'campaign.qtyLastMonth' | translate }}</th>
                                <th>{{ 'campaign.avgPrice' | translate }}</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-product>
                            <tr>
                                <td>
                                  <p-checkbox name="productCoupon.selectedProducts" value="{{ product.codice_articolo }}" [(ngModel)]="productCoupon.selectedProducts"></p-checkbox>
                                </td>
                                <td>{{product.codice_ean}}</td>
                                <td>{{product.codice_articolo}}</td>
                                <td>{{product.descrizione_articolo}}</td>
                                <td>{{product.importo_tot.toString()}} €</td>
                                <td>{{product.quantita_tot.toString()}}</td>
                                <td>{{product.prezzo_medio.toString()}} €</td>
                            </tr>
                        </ng-template>
                      </p-table>
                  </div>
              </li>
            </ul>
            <div class="ui-g-6" *ngIf="coupon.active">
                <button
                pButton
                type="button"
                class="Coupon-preview add-coupon-btn"
                icon="fa fa-plus"
                iconPos="left"
                label="Nuovo Coupon"
                (click)="addProductCoupon(coupon)">
              </button>
            </div>
          </div>
          <!-- end extra 3 -->

          <!-- extra 4 -->
          <div class="ui-g-12" *ngIf="coupon.active && coupon.type_code == 4">
            <ul class="product-coupons">
              <li class="product-coupons__single" *ngFor="let productCoupon of productCouponsNF; let i = index">
                  <div class="product-coupons__single__header ui-g-12">
                    <div class="ui-g-11">
                      <h1 style="border-bottom: 0;">Coupon {{i + 1}}</h1>
                    </div>
                    <div class="ui-g-1">
                      <i class="fa fa-2x fa-times product-coupons__single__delete" (click)="deleteProductCoupon(i, coupon.type_code)"></i>
                    </div>
                  </div>
                  <app-coupons-sliders
                  [coupon]="coupon"
                  [productCoupon]="productCoupon"
                  [typeCode]="coupon.type_code"
                  (couponSettingsChanged)="resetCoupons($event)"
                  >
                  </app-coupons-sliders>

                  <kv-search-toolbar
                  [couponCategoryFilter]="true"
                  [productsBoxEnabled]="true"
                  appQFilter
                  (onGetCouponProducts)="getCouponProductsNF($event, productCoupon)"
                  >
                  </kv-search-toolbar>
                  <div class="ui-g-12 search-toolbar-buttons">
                    <div class="ui-g-9"></div>
                    <div class="ui-g-3">
                      <button class="k-generic-btn pull-right" pButton type="button" (click)="applyCouponProductsFilter(productCoupon)" name="search" icon="fa fa-search"
                              label="{{ 'common.apply' | translate}}"></button>
                    </div>
                  </div>
                  <div class="ui-g-12" *ngIf="productCoupon.showProductsTable">
                      <p-table class="product-table" [value]="productCoupon.products" [paginator]="true" [rows]="10">
                        <ng-template pTemplate="header">
                            <tr>
                                <th></th>
                                <th>Ean</th>
                                <th>{{ 'campaign.itemCode' | translate }}</th>
                                <th>{{ 'campaign.itemDescription' | translate }}</th>
                                <th>{{ 'campaign.soldLastMonth' | translate }}</th>
                                <th>{{ 'campaign.qtyLastMonth' | translate }}</th>
                                <th>{{ 'campaign.avgPrice' | translate }}</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-product>
                            <tr>
                                <td>
                                  <p-checkbox name="productCoupon.selectedProducts" value="{{ product.codice_articolo }}" [(ngModel)]="productCoupon.selectedProducts"></p-checkbox>
                                </td>
                                <td>{{product.codice_ean}}</td>
                                <td>{{product.codice_articolo}}</td>
                                <td>{{product.descrizione_articolo}}</td>
                                <td>{{product.importo_tot.toString()}} €</td>
                                <td>{{product.quantita_tot.toString()}}</td>
                                <td>{{product.prezzo_medio.toString()}} €</td>
                            </tr>
                        </ng-template>
                      </p-table>
                  </div>
              </li>
            </ul>
            <div class="ui-g-6" *ngIf="coupon.active">
                <button
                pButton
                type="button"
                class="Coupon-preview add-coupon-btn"
                icon="fa fa-plus"
                iconPos="left"
                label="Nuovo Coupon"
                (click)="addProductCoupon(coupon)">
              </button>
            </div>
          </div>
          <!-- end extra 4 -->

        </div>

      </div>
    </div>
    <!-- end for -->

  </div>
</div>

<p-confirmDialog key="confirm"></p-confirmDialog>

<!-- **** COUPONS POPUP **** -->
<p-dialog styleClass="dialog1" header="{{ 'campaign.couponPreview' | translate }}" [(visible)]="showCouponsPreview" modal="modal" showEffect="fade" [responsive]="true" [draggable]="false" [modal]="true">

  <div class="ui-dialog-inner">

    <p-dataTable [value]="coupons" [paginator]="true" [rows]="10">
      <p-column field="descrizione_canale" header="Canale"></p-column>
      <p-column field="categoria_offerta" header="Categoria"></p-column>
      <p-column field="sigle_cluster_modello_1" header="Clienti"></p-column>
      <p-column field="descrizione_metodo" header="Tipo Sconto"></p-column>
      <p-column field="sconto" header="Sconto"></p-column>
      <p-column field="stretch" header="Stretch"></p-column>
      <p-column field="soglia" header="{{ 'campaign.threshold' | translate }}"></p-column>
      <p-column field="coupon_allocati_totali" header="Numero Clienti"></p-column>
    </p-dataTable>

  </div>

</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/campaign/new-campaign/step-4/coupons/campaign-coupons.html